import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';
import type { ColorName } from '../styles';
import { Color, getColor } from '../styles';

export interface FillCheckIconProps extends IconProps {
  /**
   * The color of the checkmark icon.
   *
   * @defaultValue 'white'
   */
  checkmarkColor?: Color | ColorName;
}

export function FillCheck(props: FillCheckIconProps) {
  const { checkmarkColor = 'white', baseColor = Color.Kale3 } = props;
  return (
    <IconSvg {...props} viewBox="0 0 44 44">
      <g>
        <circle
          fill={getColor(baseColor)}
          fillRule="nonzero"
          cx="22"
          cy="22"
          r="21"
        ></circle>
        <path
          d="M30.7075379,16.0075379 C31.1175884,15.5974874 31.7824116,15.5974874 32.1924621,16.0075379 C32.6025126,16.4175884 32.6025126,17.0824116 32.1924621,17.4924621 L21.6924621,27.9924621 C21.3084583,28.3764659 20.6949992,28.404293 20.2778064,28.0566323 L13.9778064,22.8066323 C13.5323156,22.4353901 13.4721254,21.7732971 13.8433677,21.3278064 C14.2146099,20.8823156 14.8767029,20.8221254 15.3221936,21.1933677 L20.8849,25.8283 L30.7075379,16.0075379 Z"
          fill={checkmarkColor}
          fillRule="nonzero"
        ></path>
      </g>
    </IconSvg>
  );
}
